import React from 'react';
import { Table, Card } from 'react-bootstrap';
import { FaLocationDot } from 'react-icons/fa6';

const tableContainerStyle = {
  backgroundColor: 'transparent !important',
  borderRadius: '10px',
  overflow: 'hidden',
  marginTop: '20px',
};
const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  backgroundColor: 'transparent !important',
  borderRight: '5px solid #0B1F4B',
  tableLayout: 'fixed',
};
const tableHeaderStyle = {
  backgroundColor: '#0B1F4B',
  color: 'white',
  textAlign: 'center',
  padding: '15px',
  fontWeight: 'bold',
  fontSize: '14px',
  borderBottom: '2px solid #00B2FF',
};
const sidebarCellStyle = {
  backgroundColor: '#0B1F4B',
  color: 'white',
  fontWeight: 'bold',
  textAlign: 'left',
  padding: '18px',
  border: 'none',
  fontSize: '14px',
  cursor: 'pointer',
  width: '200px',
};
const selectStyle = {
  backgroundColor: '#0B1F4B',
  color: 'white',
  border: 'none',
  fontWeight: 'bold',
  fontSize: '14px',
  padding: '5px',
  cursor: 'pointer',
  width: '100%',
  boxSizing: 'border-box',
};
const tableCellStyle = {
  backgroundColor: 'transparent',
  color: 'white',
  textAlign: 'center',
  border: 'none',
  fontSize: '12px',
  height: '80px',
  verticalAlign: 'middle',
  padding: '0',
};
const cardStyle = {
  backgroundColor: '#0B1F4B',
  color: 'white',
  alignItems: 'start',
  justifyContent: 'center',
  padding: '10px',
  height: '100%',
  width: '100%',
  borderRadius: 0,
  border: 'none',
};

const CalendarTable = ({
  realDays,
  delegations,
  selectedDelegation,
  onChangeDelegation,
  employees,
  shifts,
  visibleGroups,
  toggleGroupVisibility,
}) => (
  <div style={tableContainerStyle}>
    <Table style={tableStyle}>
      <thead>
        <tr>
          <th style={sidebarCellStyle}>
            <select style={selectStyle} value={selectedDelegation} onChange={onChangeDelegation}>
              {delegations.map((d, i) => (
                <option key={i} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </th>
          {realDays.map((day, i) => (
            <th key={i} style={tableHeaderStyle}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '20px',
                }}
              >
                <span>{day.day}</span>
                <div
                  style={{
                    backgroundColor: '#0E46A3',
                    color: 'white',
                    borderRadius: '50%',
                    width: '30px',
                    height: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {day.date}
                </div>
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={tableCellStyle}>
            <Card style={{ ...cardStyle, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px', justifyContent: 'start' }}>
              <img
                src="https://i.pravatar.cc/100?img=1"
                alt="Avatar"
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                }}
              />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Simão Ferreira</span>
                <span style={{ fontSize: '12px', color: '#B0B0B0' }}>Full Stack Dev</span>
              </div>
            </Card>
          </td>
          {realDays.map((_, idx) => {
            const shift = shifts[Math.floor(Math.random() * shifts.length)];
            return (
              <td key={idx} style={tableCellStyle}>
                <Card
                  style={{
                    backgroundColor: shift.color,
                    padding: '10px',
                    borderRadius: '5px',
                    textAlign: 'center',
                    margin: '5px',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <div
                      style={{
                        height: '3rem',
                        borderRadius: '3px',
                        width: '0.5rem',
                        backgroundColor: shift.name === 'Ausência' ? '#800100' : '#014421',
                        marginRight: '10px',
                      }}
                    />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flexGrow: 1,
                      }}
                    >
                      {shift.time ? (
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{shift.time}</span>
                      ) : (
                        <span style={{ fontWeight: 'bold', color: '#800100' }}>{shift.name}</span>
                      )}
                      {shift.name !== 'Ausência' && (
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            fontWeight: 'semibold',
                          }}
                        >
                          <FaLocationDot style={{ height: '15px' }} />
                          {shift.name}
                        </span>
                      )}
                    </div>
                  </div>
                </Card>
              </td>
            );
          })}
        </tr>
        {Object.keys(employees).map((group) => (
          <React.Fragment key={group}>
            <tr>
              <td
                colSpan={realDays.length + 1}
                style={{
                  ...sidebarCellStyle,
                  textAlign: 'center',
                  cursor: 'pointer',
                  backgroundColor: '#0B1F4B',
                  border: '3px solid #17296B',
                  borderBottom: visibleGroups[group] ? '3px solid #17296B' : 'none',
                  fontWeight: 'bold',
                  verticalAlign: 'middle',
                  padding: '0.5rem',
                  height: '50px',
                  borderLeft: 'none',
                }}
                onClick={() => toggleGroupVisibility(group)}
              >
                {group} {visibleGroups[group] ? '▼' : '▲'}
              </td>
            </tr>
            {visibleGroups[group] &&
              employees[group].map((name, i) => (
                <tr key={i}>
                  <td style={tableCellStyle}>
                    <Card style={{ ...cardStyle, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px', justifyContent: 'start' }}>
                      <img
                        src={`https://i.pravatar.cc/100?img=${i + 1}`}
                        alt="Avatar"
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                        }}
                      />
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{name}</span>
                        <span style={{ fontSize: '12px', color: '#B0B0B0' }}>Full Stack Dev</span>
                      </div>
                    </Card>
                  </td>
                  {realDays.map((_, idx2) => {
                    const shift = shifts[Math.floor(Math.random() * shifts.length)];
                    return (
                      <td key={idx2} style={tableCellStyle}>
                        <Card
                          style={{
                            backgroundColor: shift.color,
                            padding: '10px',
                            borderRadius: '5px',
                            textAlign: 'center',
                            margin: '5px',
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <div
                              style={{
                                height: '3rem',
                                borderRadius: '3px',
                                width: '0.5rem',
                                backgroundColor: shift.name === 'Ausência' ? '#800100' : '#014421',
                                marginRight: '10px',
                              }}
                            />
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                flexGrow: 1,
                              }}
                            >
                              {shift.time ? (
                                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{shift.time}</span>
                              ) : (
                                <span style={{ fontWeight: 'bold', color: '#800100' }}>{shift.name}</span>
                              )}
                              {shift.name !== 'Ausência' && (
                                <span
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    fontWeight: 'semibold',
                                  }}
                                >
                                  <FaLocationDot style={{ height: '15px' }} />
                                  {shift.name}
                                </span>
                              )}
                            </div>
                          </div>
                        </Card>
                      </td>
                    );
                  })}
                </tr>
              ))}
          </React.Fragment>
        ))}
      </tbody>
    </Table>
  </div>
);

export default CalendarTable;